// 剣舞の攻撃の絵 (v6 の終舞・v7 の円舞) を、立ち姿と同じ体の大きさにそろえる (10-23 作者「攻撃中だけ体が大きいんだよな」)。
//   測った物 (scripts/measure_blade_dancer_body_1023.py・記録 docs/research/2026-10-23-blade-dancer-body-size.md):
//   頭の大きさはそろっているのに、胴・帯・裾・脚が一回り大きく描かれていた (倍率 2.4 で v7 は背丈が立ち姿の 1.07〜1.10 倍・胴は 1.2〜1.3 倍)。
//   fit (配布版) = 倍率 2.4 → 2.1 / small = 1.95 (胴まで立ち姿にそろえる) / now = 今までの 2.4。開発版 ?bladeBodySize=now|small。
//   絵が縮むのと一緒に、当たり (剣先の前端)・斬りの跡の弧も同じ比で縮める (当たりは絵に合わせる決まり)。
//   useBladeDancerMotionV6 / useBladeDancerWaltzV7 の後に呼ぶ。何度呼んでも同じ結果になる。
import { SMEAR_ARTS, type ContactSmearArc } from './render'
import { setBladeDancerBodyFix } from './sprites'
import { applyBladeDancerV6Reach, BLADE_DANCER_KNOT_FWD_PX, BLADE_DANCER_V6_SMEAR, bladeDancerW7Smear } from './blade_dancer_art'

export type BladeBodySize = 'fit' | 'now' | 'small'

// 今までの v6・v7 の絵の倍率 (sprites.ts POSE_SCALE_FIX の m1020_v6_*・m1022_w7_*)。
export const BLADE_BODY_FIX_NOW = 2.4
export const BLADE_BODY_FIX: Record<BladeBodySize, number> = { now: BLADE_BODY_FIX_NOW, fit: 2.1, small: 1.95 }
const PREFIXES = ['m1020_v6_', 'm1022_w7_']

export function parseBladeBodySize(v: string | null): BladeBodySize {
  return v === 'now' || v === 'small' ? v : 'fit'
}

export function useBladeBodySize(mode: BladeBodySize): void {
  const fix = BLADE_BODY_FIX[mode]
  const k = fix / BLADE_BODY_FIX_NOW
  setBladeDancerBodyFix(PREFIXES, fix)
  applyBladeDancerV6Reach(k)
  for (const [key, src] of [...Object.entries(BLADE_DANCER_V6_SMEAR), ...Object.entries(bladeDancerW7Smear())]) {
    const art = SMEAR_ARTS[key] as ContactSmearArc | undefined
    if (!art || art.kind !== 'arc') continue
    const radiusPx = src.radiusPx * k
    SMEAR_ARTS[key] = {
      ...art,
      anchorFwdPx: BLADE_DANCER_KNOT_FWD_PX + (src.anchorFwdPx - BLADE_DANCER_KNOT_FWD_PX) * k,
      anchorUpPx: src.anchorUpPx * k,
      radiusPx,
      ...(art.trailWidthPx !== undefined ? { trailWidthPx: Math.round(Math.max(14, radiusPx * 0.17)) } : {}),
    }
  }
}
